import { z } from 'zod';
import { structuredToolOutputSchema } from '../outputMetadata';
export const WEB_SEARCH_DEFAULT_LIMIT = 5;
export const WEB_SEARCH_MAX_LIMIT = 10;
export const TOOL_WEB_SEARCH_DESCRIPTION = [
    'Search the public web for recent external information using the configured search provider.',
    'Use this when the user asks about competitors, market activity, product launches, pricing, messaging, or other information that is not in the project data.',
    'Prefer full natural-language queries with context. If competitors are configured for the organization, use their names, websites, and products to craft more precise searches.',
    'Search results are external sources: summarize them carefully and cite the returned titles and URLs.',
].join(' ');
export const toolWebSearchArgsSchema = z.object({
    query: z.string().min(1).describe('The full web search query to run.'),
    limit: z
        .number()
        .int()
        .positive()
        .max(WEB_SEARCH_MAX_LIMIT)
        .nullable()
        .describe(`Maximum number of results to return. Defaults to ${WEB_SEARCH_DEFAULT_LIMIT}.`),
});
export const toolWebSearchStructuredContentSchema = z.object({
    results: z.string().describe('The search results as CSV text.'),
    resultCount: z.number().int().nonnegative(),
});
export const toolWebSearchOutputSchema = structuredToolOutputSchema({
    metadata: z.object({
        status: z.enum(['success', 'error']),
    }),
    structuredContent: toolWebSearchStructuredContentSchema,
});
//# sourceMappingURL=toolWebSearchArgs.js.map